var App = App || {};

App.InitBehavior = (function() {
  'use strict';

  var initialize = function() {
    _smoothScrolling();
    _detectTouch();
  };

  var _smoothScrolling = function() {
    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      var target = $(this).attr('href');
      if (target.length > 1) {
        $('html, body').animate({
          scrollTop: $(target).offset().top
        }, 2000);
      }
    });
  };

  var _detectTouch = function() {
    if ('ontouchstart' in window ||
        window.DocumentTouch &&
        document instanceof DocumentTouch) {
      $('body').addClass('touch');
    }
  };

  return {
    initialize: initialize
  };
}());